import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LoaderService } from '@shared/services/loader.service';
import { DriverService } from '@core/services/driver.service';
import { CancelBookingRequest, CancelBookingType, ModalData } from '@core/models/api.response.modal';
import { ToastService } from '@shared/services/toast.service';
import { GroupUserService } from '@core/services/group-user.service';
import { USER_ROLES } from '@shared/constant/shared.constant';
import { SuperAdminService } from '@core/services/super-admin.service';
import { autoUnsubWith } from '@shared/services/utility.abstract';
@Component({
  selector: 'app-cancel-booking-driver',
  templateUrl: './cancel-booking-driver.component.html',
  styleUrls: ['./cancel-booking-driver.component.scss']
})
export class CancelBookingDriverComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  fetchModalData: ModalData;
  type: number = 1;
  totalAmount: number;
  userRoles = USER_ROLES;

  constructor(
    public readonly loaderService: LoaderService,
    public readonly driverService: DriverService,
    private readonly ref: DynamicDialogRef,
    private readonly config: DynamicDialogConfig,
    private readonly groupUserService: GroupUserService,
    private readonly toastService: ToastService,
    private readonly superAdminService:SuperAdminService
  ) { }

  ngOnInit(): void {
    this.fetchModalData = this.config.data;
    this.calculateTotalAmount();
  }

  calculateTotalAmount(): void {
    if (this.fetchModalData) {
      const { usedCredit, total } = this.fetchModalData;
      if (usedCredit !== undefined && total !== undefined) {
        if (usedCredit > 0 && total === 0) {
          this.totalAmount = usedCredit;
        } else if (usedCredit === 0 && total > 0) {
          this.totalAmount = total;
        } else if (usedCredit > 0 && total > 0) {
          this.totalAmount = total + usedCredit;
        }else{
          this.totalAmount = total
        }
      }
    }
  }

  confirm(): void {
    
    const request: CancelBookingRequest = {
      bookingId: this.fetchModalData.id,
      type: this.type,
    };
    if (this.fetchModalData.role === this.userRoles.GROUP_USER) {
      Object.assign(request, {
        cancelBookingType: CancelBookingType.FullCancelBooking,
        slotCount: 0
      });
    }
    const cancelService = this.groupUserService

    const cancelMethod =  'cancelOneTimeBookingBySuperAdmin';

    cancelService[cancelMethod](request)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: ({ message }) => this.handleSuccessResponse(message),
      error: (error) => this.handleErrorResponse(error.error.message)
    });
  }

  recurringBookingCancel(): void {
    
    const request= {
      bookingId:this.fetchModalData.id,
      slotCount: 0,
      cancelBookingType: 0,
      isOnlySubscriptionCancel: false
    }
    this.superAdminService.cancelRecurringBooking(request)
    .pipe(autoUnsubWith(this.destroyRef))
    .subscribe({
      next: ({ message }) => this.handleSuccessResponse(message),
      error: (error) => this.handleErrorResponse(error.error.message)
    });
  }

  handleSuccessResponse(message: string): void {
    
    this.toastService.showToastMessage('success', 'Success', message)
    setTimeout(() => {
      this.closeDialog();
      this.loaderService.reload();
  }, 1000);
  }
  handleErrorResponse(message: string): void {
    
    this.toastService.showToastMessage('error', 'Error', message)
  }
  closeDialog(): void {
    this.ref.close();
  }
}
